import React from "react";

const Blog5 = () => {
  return (
    <div>
      <div className="blog">
        <div className="row">
          <div className="col-md-9 article-area">
            <h2
              style={{ marginTop: "85px" }}
              className="mb-5 text-center project-title "
            >
              Javascript HTML DOM Method
            </h2>
            <div style={{ justifyContent: "center" }} className="d-flex">
              <img
                width="100%"
                className="img-fluid"
                src="https://i.ibb.co/611VLVs/download-1.png"
                alt="css-flexbox"
              />
            </div>
            <br />
            <article>
              <p>
                <b>1. What is JavaScript work? And How does it works?</b>
              </p>
              <p>
                Javascript is a single-threaded asynchronous programming
                language. It runs code line by line. It is a high-level
                programming language. That means it is very understandable to
                human language. It is used in the browser engine. It handles all
                the website interactions. Browsers can not understand any code
                except javascript.
              </p>
              <br />
              <p>
                The event loop is the secret behind the javascript asynchronous
                nature. Though javascript is a single-threaded programming
                language it sometimes looks multithreaded for its asynchronous
                nature. And the secret behind that is the event loop.
              </p>
              <br />
              <p>
                The event loop is always running behind the language and it
                monitors the call stack and it works in an asynchronous way.
              </p>
              <br />
              <p>
                avascript is an interpreter language. The browser is built with
                a compiler language. So the browser engine read over the code
                like an interpreter and it compiles through the browser itself
                and compiles in binary code and runs in a machine.
              </p>
              <br />
              <p>
                The Javascript is executed in the browser line by line. Because
                it is a single-threaded language also.
              </p>
              <br />
              <br />
              <p>
                <b>2. The JavaScrit DOM Method</b>
              </p>
              <p>
                The Javascript DOM is a method that allows scripts to
                dynamically access the HTML and update the content, structure,
                and style of a document. The full meaning of DOM is Document
                Object Model.
              </p>
              <br />
              <p>
                If we think A web page is a document that displays in the
                browser window. The Dom is not part of Javascript. But it is
                manipulated by JavaScript. We use Dom to select HTML elements.
                DOM plays a very vital role in a modern website. It changes the
                way of website interaction.
              </p>
              <br />
              <br />
              <p>
                <b>3. var, let, and const</b>
              </p>
              <p>
                The var, let and the const all are variable but there are some
                differences between them. The const variable can not change its
                value. In the let variable, we can re-assign the value. And the
                var variable is a global variable. If we call var in a function,
                we can also call it outside of the function but with the two
                others, we can not call the variable outside of the variable.
              </p>
              <br />
              <br />
              <p>
                <b>4. Is that undefined or null?</b>
              </p>
              <p>
                We make mistakes in javascript on undefine and null to
                understand. The undefined is a primitive value that represents a
                null value. That means it defines that there is no value in an
                object. It can not assign to a variable. That means can not
                declare a variable with an undefined value.
              </p>
              <br />
              <p>
                On the other hand, we can assign a variable with a null value to
                show the value of the variable is empty.
              </p>
              <br />
              <br />
              <p>
                <b>5. How will you debug a JavaScript application?</b>
              </p>
              <p>
                Debugging a code is a very important job to a developer. A
                developer needs to know how to debug the code. There are many
                different ways to debug code based on the preferred language.
                But in javascript debugging can be very interesting if we know
                how to debug code very well.
              </p>
              <br />
              <p>
                The first step we can follow to debug the code is using the
                console. If there are any errors in the code and we can’t
                understand what the problem is then we can use a console log to
                print the code in the console. And by this, we can see what the
                problem is.
              </p>
              <br />
              <p>
                Second, we can use browser debugging tools. We can use our code
                editor as a debugging tool. And doing these steps and following
                some rules we can debug code very easily.
              </p>
            </article>
          </div>
          {/*--------------- Adds section -------------- */}
          <div className="col-md-3">
            <img
              style={{ marginTop: "70px" }}
              src="https://i.ibb.co/HXcfLN6/9656093656252652900.gif"
              alt=""
              className="img-fluid"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Blog5;
